import { ListDecorator } from '../constants-types/PiList.model';

export interface SetObject {
    id: string;
}
export class ResultSet<T extends SetObject> extends ListDecorator<T> {
    private inSet: {
        [key: string]: boolean;
    } = {};

    constructor(oldList?: Iterable<T>) {
        super(oldList);
    }

    // TODO the behavior of this has changed, replace will no longer work
    isInResultSet(result: T): boolean {
        // Could replace this with util.hasValue but that would mean factory builder
        if (this.inSet[result.id] !== true && this.inSet[result.id] !== false) {
            this.inSet[result.id] = !!this.find(
                (item) => item.id === result.id
            );
        }
        return this.inSet[result.id];
    }

    // TODO - type here has change to make it Immutable
    addToResultSet(result: T): this {
        const index = this.findIndex((item) => item.id === result.id);
        if (index === -1) {
            return this.push(result);
        } else {
            return this.set(index, result);
        }
    }
    // TODO - type here has change to make it Immutable
    removeFromResultSet(result: T): this {
        const index = result
            ? this.findIndex((item) => item.id === result.id)
            : -1;
        return index > -1 ? this.delete(index) : this;
    }
    // TODO - type here has change to make it Immutable
    toggleFromResultSet(result: T): this {
        if (this.isInResultSet(result)) {
            return this.removeFromResultSet(result);
        }
        return this.addToResultSet(result);
    }

    noResultsInContext(contents: T[]): boolean {
        return contents.every((result) => !this.isInResultSet(result));
    }

    allResultsInContext(contents: T[]): boolean {
        return (
            contents.length &&
            contents.every((result: T) => this.isInResultSet(result))
        );
    }
    // TODO Change usages
    // Note I am not preserving order. If Order becomes important
    // this should be alterred
    // Note that we need the typing becase TypeScript gets confused by
    // the returned by push.
    addRowSet(results: T[]): this {
        return this.removeRowSet(results).push(...results);
    }

    removeRowSet(results: T[]): this {
        // make a hash of result Ids
        const valuesToRemove: {
            [key: string]: T;
        } = {};
        results.forEach((result) => (valuesToRemove[result.id] = result));
        return this.makeMyself(
            this.filter((item): item is T => !valuesToRemove[item.id])
        );
    }

    makeCopy() {
        return this.constructor(this);
    }
}
